<template>
  <div class="card-form">
    <PageTable
      ref="pageTable"
      :loading="loading"
      :tableData="tableData"
      :tableHeight="tableHeight"
      :tablePage="page"
      :multiple="multiple"
      :reserve="reserve"
      :highlight="highlight"
      @reload="reload"
      @choose-change="(e) => $emit('choose-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        :amzSpuStatusList="amzSpuStatusList"
        @query="getData"
        @reset="resetPage"
      />
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="firstChooseSPUList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader, SortFieldsPopover },
  props: {
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    tableHeight: { type: Number, default: 800 },
    method: { type: String, default: 'POST' },
    extraData: { type: Object, default: () => {} },
    amzSpuStatusList: { type: Array, default: () => [] },
  },
  data() {
    return { usePage: true, sortFields: [] }
  },
  methods: {
    getData(form) {
      this.loading = true
      const params = {
        ...form,
        ...this.page,
        ...(this.extraData || {}),
        sortFields: this.sortFields,
      }
      const method = (this.method || 'GET').toUpperCase()

      request({
        url: '/ecom/ecom/amz/spu/awsSample/list',
        method: method,
        data: method == 'POST' ? params : null,
        params: method == 'GET' ? params : null,
      })
        .then((res) => {
          this.loading = false
          this.setData(res)
          if (!this.reserve) this.$emit('choose-change', null)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
